/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endsnextday2Inputs */

const en_endsnextday2 = /** @type {(inputs: Endsnextday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+1 day`)
};

const de_endsnextday2 = /** @type {(inputs: Endsnextday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+1 Tag`)
};

/**
* | output |
* | --- |
* | "+1 day" |
*
* @param {Endsnextday2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const endsnextday2 = /** @type {((inputs?: Endsnextday2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endsnextday2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_endsnextday2(inputs)
	return de_endsnextday2(inputs)
});
export { endsnextday2 as "endsNextDay" }